<template>
  <div>
    <v-dialog
      v-model="dialogDetail"
      persistent
      max-width="950"
      max-height="404"
      class="d-dialog"
    >
      <v-card style="border-radius:14px">
        <div v-resize="onResize" id="detail-dialog-admin">
          <div
            class="d-dialog"
            :style="{
              padding:
                windowSize < 600 ? '0px 5px 10px 0px' : '25px 25px 15px 25px'
            }"
          >
            <div style="width:100%;display:flex">
              <div
                :style="{
                  padding:
                    windowSize < 600 ? '20px 10px 0px 10px' : '0px 0px 0px 0px',
                  width: '20%'
                }"
              >
                <div class="btn-filter-head" :style="{ border: tab === 'userDetail' ? '1px solid #333' : 'none', backgroundColor: tab === 'userDetail' ? '' : 'transparent', cursor: 'pointer' }" @click="tab = 'userDetail'">User Detail</div>
              </div>
              <div
                :style="{
                  padding:
                    windowSize < 600 ? '20px 10px 0px 10px' : '0px 0px 0px 5px',
                  width: '70%'
                  
                }"
              >
                <div class="btn-filter-head" :style="{ border: tab === 'shipment' ? '1px solid #333' : 'none', backgroundColor: tab === 'shipment' ? '' : 'transparent', cursor: 'pointer' }" @click="tab = 'shipment'">Shipment</div>
              </div>
              <div
                :style="{
                  padding:
                    windowSize < 600 ? '25px 2px 0px 0px' : '5px 5px 0px 0px',
                  'text-align': 'end',
                  width: '30%'
                  
                }"
                @click="close()"
              >
                <v-icon
                  v-text="'mdi-close'"
                  style="color:#000000;cursor:pointer"
                  size="24"
                ></v-icon>
              </div>
            </div>
            <div v-if="tab === 'userDetail'" class="box-detail">
              <b-container
                style="font-family:'Bai Jamjuree', sans-serif"
                class=" accentbv-example-row"
              >
                <b-row>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">รหัสผู้ใช้งาน</div>
                      <div class="detail" style="">{{ this.data.user_id }}</div>
                    </div>
                  </b-col>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">ชื่อ</div>
                      <div class="detail" style="">
                        <md-field
                          style="width: 100%;margin:0;min-height:0px;padding:0"
                        >
                          <md-input
                            v-model="data.user_name"
                            :disabled="true"
                            class="input-style"
                          >
                          </md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">อีเมล</div>
                      <div class="detail" style="">
                        <md-field
                          style="width: 100%;margin:0;min-height:0px;padding:0"
                        >
                          <md-input
                            v-model="data.user_email"
                            :disabled="true"
                            class="input-style"
                          >
                          </md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-col>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">วันที่สร้าง</div>
                      <div class="detail" style="">
                        {{ formatDate(data.user_create_date) }}
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">
                        {{ this.editPassword ? 'รหัสผ่านใหม่ ' : 'รหัสผ่าน' }}
                        <span v-if="editPassword" style="color:red">*</span>
                      </div>
                      <div class="detail" style="">
                        <md-field
                          v-if="!editPassword"
                          :md-toggle-password="false"
                          :style="{
                            'background-color': editUser ? '#fff' : '#DADADA',
                            border: editUser
                              ? '1px solid rgba(0, 0, 0, 0.12)'
                              : ''
                          }"
                          class="input-style"
                          style="width: 100%;margin:0;min-height:0px;padding:0"
                        >
                          <md-input
                            v-model="data.user_email"
                            :disabled="true"
                            type="password"
                            class="input-style"
                            :style="{
                              'background-color': editUser ? '#fff' : '#DADADA'
                            }"
                          >
                          </md-input>
                          <div style="display: flex;" v-if="editUser">
                            <span
                              @click="cheang_password"
                              style="display: flex;padding:0 10px 0 0;font-size:12px;align-items: center;cursor: pointer;"
                              >เปลี่ยน</span
                            >
                          </div>
                        </md-field>

                        <md-field
                          v-else
                          v-bind:class="[Error.errorClassNewPwd]"
                          :md-toggle-password="false"
                          :style="{
                            border:
                              Error.errorClassNewPwd == ''
                                ? '1px solid rgba(0, 0, 0, 0.12)'
                                : '',
                            'background-color': '#fff'
                          }"
                          class="input-style"
                          style="width: 100%;margin:0;min-height:0px;padding:0"
                        >
                          <md-input
                            v-model="edit_val.new_password"
                            :disabled="false"
                            :type="
                              !this.icon_eye.password ? 'password' : 'text'
                            "
                            style="background-color:#fff"
                            class="input-style"
                          >
                          </md-input>
                          <div style="display: flex;">
                            <span
                              v-if="!this.icon_eye.password"
                              @click="HideShow('password')"
                              style="cursor: pointer;padding:0 10px 0 0;"
                              class="md-suffix mdi mdi-eye-off"
                            ></span>
                            <span
                              v-else
                              @click="HideShow('password')"
                              style="cursor: pointer;padding:0 10px 0 0;"
                              class="md-suffix mdi mdi-eye"
                            ></span>
                          </div>
                        </md-field>
                        <div
                          v-if="this.Error.errorClassNewPwd_txt != ''"
                          class="txt-wrong"
                        >
                          <span class="mdi mdi-alert-octagon"></span>
                          {{ this.Error.errorClassNewPwd_txt }}
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">เข้าใช้งานล่าสุด</div>
                      <div class="detail" style="">
                        {{ formatDate(data.user_latest_login) }}
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <!--NOT EDIT PASS -->
                <b-row v-if="!editPassword">
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">ชื่อบริษัท</div>
                      <div class="detail" style="">
                        <md-field
                          style="width: 100%;margin:0;min-height:0px;padding:0"
                        >
                          <md-input
                            v-model="data.user_company"
                            :disabled="true"
                            class="input-style"
                          >
                          </md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-col>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">อัปเดตล่าสุด</div>
                      <div class="detail" style="">
                        {{ formatDate(data.user_latest_active) }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <!-- ///// -->

                <!-- EDIT PASS -->
                <b-row v-else>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">
                        ยืนยันรหัสผ่านใหม่ <span style="color:red">*</span>
                      </div>
                      <div class="detail" style="">
                        <md-field
                          v-bind:class="[Error.errorClassConfNewPwd]"
                          :md-toggle-password="false"
                          :style="{
                            border:
                              Error.errorClassConfNewPwd == ''
                                ? '1px solid rgba(0, 0, 0, 0.12)'
                                : '',
                            'background-color': '#fff'
                          }"
                          class="input-style"
                          style="width: 100%;margin:0;min-height:0px;padding:0"
                        >
                          <md-input
                            v-model="edit_val.confrim_password"
                            :disabled="false"
                            :type="
                              !this.icon_eye.confrim_new_password
                                ? 'password'
                                : 'text'
                            "
                            style="background-color:#fff"
                            class="input-style"
                          >
                          </md-input>
                          <div style="display: flex;">
                            <span
                              v-if="!this.icon_eye.confrim_new_password"
                              @click="HideShow('confrim_new_password')"
                              style="cursor: pointer;padding:0 10px 0 0;"
                              class="md-suffix mdi mdi-eye-off"
                            ></span>
                            <span
                              v-else
                              @click="HideShow('confrim_new_password')"
                              style="cursor: pointer;padding:0 10px 0 0;"
                              class="md-suffix mdi mdi-eye"
                            ></span>
                          </div>
                        </md-field>
                        <div
                          v-if="this.Error.errorClassConfNewPwd != ''"
                          class="txt-wrong"
                        >
                          <span class="mdi mdi-alert-octagon"></span>
                          {{ this.Error.errorClassConfNewPwd_txt }}
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">อัปเดตล่าสุด</div>
                      <div class="detail" style="">
                        {{ data.user_latest_active }}
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <b-row v-if="editPassword">
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head">ชื่อบริษัท</div>
                      <div class="detail" style="">
                        <md-field
                          style="width: 100%;margin:0;min-height:0px;padding:0"
                        >
                          <md-input
                            v-model="data.user_company"
                            :disabled="true"
                            class="input-style"
                          >
                          </md-input>
                        </md-field>
                      </div>
                    </div>
                  </b-col>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head"></div>
                      <div class="detail" style=""></div>
                    </div>
                  </b-col>
                </b-row>
                <!-- ///// -->
                <b-row>
                  <b-col style="padding:10px 0 10px 10px" xl>
                    <div class="md-layout">
                      <div class="head">สถานะ</div>
                      <div class="detail" style="">
                        <div style="padding:0" class="md-layout box-inp">
                          <div>
                            <v-sheet v-if="editUser">
                              <v-switch
                                inset
                                @change="switch_user(data)"
                                v-model="switch1"
                                color="#58A55C"
                                style="height: 25px;top: 5px;margin-top: 0px;padding-top: 0px"
                              >
                              </v-switch>
                              <small style="font-size:12px;color:#898A8D">{{
                                data.user_status == 1 ? 'on' : 'off'
                              }}</small>
                            </v-sheet>
                          </div>

                          <div
                            :class="'btn-filter ' + renderStatus(data, 'class')"
                          >
                            {{ renderStatus(data, 'text') }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col style="padding:10px 0 0 10px" xl>
                    <div class="md-layout">
                      <div class="head"></div>
                      <div class="detail" style=""></div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
              <div class="box-footer">
              <span
                v-if="editUser"
                @click="edit('cancel')"
                style="cursor: pointer;"
                >ยกเลิก</span
              >
              <v-btn
                v-if="!editUser"
                rounded
                @click="edit('edit')"
                class="ok"
                :style="{ 'margin-left': '20px' }"
                >แก้ไข</v-btn
              >

              <v-btn
                v-else
                rounded
                @click="edit('save')"
                class="ok"
                :style="{ 'margin-left': '20px' }"
                >บันทึก</v-btn
              >
            </div>
            </div>
            <div v-if="tab === 'shipment'" class="box-detail">
              
              
              <div style="max-height: 600px; overflow-y: auto; padding-right: 8px;">
                <v-container>
                  <template v-if="userShipmentList.length > 0">
                    <v-row v-for="(shipment, index) in userShipmentList" :key="index" justify="center">
                      <v-col cols="12" sm="12" md="12">
                        <v-card class="shipment-card" :style="{ 
                          width: '100%', 
                          margin: '0 auto', 
                          position: 'relative',
                          border: shipment.is_default === 1 ? '2px solid #4CAF50' : '1px solid #e0e0e0'
                        }">
                          <!-- Default indicator -->
                          <div v-if="shipment.is_default === 1" style="position: absolute; top: 8px; right: 8px; z-index: 2;">
                            <v-icon color="#4CAF50" size="24">mdi-check-circle</v-icon>
                          </div>
                          <v-card-text>
                            <div style="font-weight:bold; font-size:16px;">
                              {{ shipment.from_name }} <span style="margin:0 8px;">|</span> {{ shipment.from_tel }}
                            </div>
                            <div style="color:#555; margin-top:6px;">
                              {{ shipment.from_address }},
                              {{ shipment.from_state }},
                              {{ shipment.from_district }},
                              {{ shipment.from_province }},
                              {{ shipment.from_postcode }}
                            </div>
                            <div style="display: flex; justify-content: flex-end; margin-top: 16px;">
                              <div
                                variant="text"
                                small
                                @click="editShipment(shipment, index)"
                                style="color: #1976d2; text-transform: none; margin-right: 8px; cursor: pointer;"
                              >
                                แก้ไข
                              </div>
                              <div
                                variant="text"
                                small
                                @click="deleteShipment(shipment, index)"
                                style="color: #1976d2; text-transform: none; cursor: pointer;"
                              >
                                ลบ
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-else>
                    <div style="text-align:center; color:#888; padding: 32px 0; font-size: 32px;">
                      ไม่มีข้อมูล
                    </div>
                  </template>
                </v-container>
              </div>
              
              <div style="padding:10px 20px 20px 0;width:100%;text-align:end;">
                <v-btn
                  rounded
                  @click="openAddShipmentDialog()"
                  class="ok"
                  style="padding:20px 10px 20px 10px;width:unset"
                >
                  เพิ่มที่อยู่จัดส่ง
                </v-btn>
              </div>

              <!-- Dialog for adding new shipment -->
              <v-dialog v-model="dialogAddShipment" persistent max-width="800px">
                <v-card style="border-radius:14px">
                  <div v-resize="onResize" id="detail-dialog-admin">
                    <div class="d-dialog" :style="{padding: windowSize < 600 ? '0px 5px 10px 0px' : '25px 25px 15px 25px'}">
                      <div style="width:100%;display:flex">
                        <div :style="{padding: windowSize < 600 ? '20px 10px 0px 10px' : '0px 0px 0px 5px', width: '70%'}">
                          <div class="btn-filter-head" style="white-space: nowrap; overflow: visible; width: 40%; min-width: fit-content;">{{ isEditShipment ? 'แก้ไขที่อยู่การจัดส่ง' : 'เพิ่มที่อยู่การจัดส่ง' }}</div>
                        </div>
                      </div>
                      <div class="box-detail">
                        <b-container style="font-family:'Bai Jamjuree', sans-serif" class="accentbv-example-row">
                          <b-row style="margin-bottom: 0px;">
                            <b-col xl style="padding: 0px 1px 0px 1px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 90px;">
                                  ผู้ส่ง <span v-if="!newShipment.acc_name" style="color:red">*</span>
                                </div>
                                <div class="detail" style="flex: 1;">
                                  <md-field>
                                    <md-input
                                      v-model="newShipment.acc_name"
                                      :class="Error.errorName"
                                      class="input-style2"
                                    ></md-input>
                                  </md-field>
                                  <div v-if="Error.errorName" class="txt-wrong">{{ Error.errorMsg }}</div>
                                </div>
                              </div>
                            </b-col>
                            <b-col xl style="padding: 0px 1px 0px 10px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 90px;">
                                  เบอร์โทร <span v-if="!newShipment.acc_phone" style="color:red">*</span></div>
                                <div class="detail" style="flex: 1;">
                                  <md-field>
                                    <md-input
                                      v-model="newShipment.acc_phone"
                                      :class="Error.errorPhone"
                                      class="input-style2"
                                    ></md-input>
                                  </md-field>
                                  <div v-if="Error.errorPhone" class="txt-wrong">{{ Error.errorMsg }}</div>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row style="margin-bottom: 0px;">
                            <b-col xl style="padding: 0px 1px 0px 1px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head-address" >
                                  ที่อยู่ <span v-if="!newShipment.acc_address" style="color:red">*</span>
                                </div>
                                <div class="detail" style="flex: 1;">
                                  <md-field style="width: 100%;">
                                    <md-input
                                      v-model="newShipment.acc_address"
                                      :class="Error.errorAddress"
                                      class="input-style2"
                                      style="width: 100%; ;"
                                    ></md-input>
                                  </md-field>
                                  <div v-if="Error.errorAddress" class="txt-wrong">{{ Error.errorMsg }}</div>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row style="margin-bottom: 0px;">
                            <b-col xl style="padding: 0px 1px 0px 1px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 60px; margin-right: 8px;">จังหวัด <span v-if="!newShipment.acc_province" style="color:red">*</span></div>
                                <div class="detail" style="flex: 1;">
                                  <md-field>
                                    <v-select
                                      v-model="newShipment.acc_province"
                                      :items="provinceList.map(p => ({ text: p.PROVINCE_NAME, value: p.PROVINCE_NAME }))"
                                      item-text="text"
                                      item-value="value"
                                      label="-กรุณาเลือกจังหวัด-"
                                      solo
                                      dense
                                      style="
                                        font-family: 'Bai Jamjuree', sans-serif;
                                        width: 320px;
                                        max-width: 100%;
                                        min-width: 180px;
                                      "
                                      v-bind:class="[Error.errorProvince]"
                                    />
                                  </md-field>
                                  <div v-if="Error.errorProvince" class="txt-wrong">{{ Error.errorMsg }}</div>
                                </div>
                              </div>
                            </b-col>
                            <b-col xl style="padding: 0px 1px 0px 10px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 60px; margin-right: 8px;">เขต/อำเภอ <span v-if="!newShipment.acc_district" style="color:red">*</span></div>
                                <div class="detail" style="flex: 1;">
                                  <md-field>
                                    <v-select
                                      v-model="newShipment.acc_district"
                                      :items="districtList.map(d => ({ text: d.DISTRICT_NAME.replace(/^\*/, ''), value: d.DISTRICT_NAME.replace(/^\*/, '') }))"
                                      item-text="text"
                                      item-value="value"
                                      label="-กรุณาเลือกเขต/อำเภอ-"
                                      solo
                                      dense
                                      style="
                                        font-family: 'Bai Jamjuree', sans-serif;
                                        width: 320px;
                                        max-width: 100%;
                                        min-width: 180px;
                                      "
                                      v-bind:class="[Error.errorDistrict]"
                                    />
                                  </md-field>
                                  <div v-if="Error.errorDistrict" class="txt-wrong">{{ Error.errorMsg }}</div>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row style="margin-bottom: 0px;">
                            <b-col xl style="padding: 0px 1px 0px 1px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 60px; margin-right: 8px;">แขวง/ตำบล <span v-if="!newShipment.acc_sub_district" style="color:red">*</span></div>
                                <div class="detail" style="flex: 1;">
                                  <md-field>
                                    <v-select
                                      v-model="newShipment.acc_sub_district"
                                      :items="subDistrictList.map(s => ({ text: s.SUB_DISTRICT_NAME.replace(/^\*/, ''), value: s.SUB_DISTRICT_NAME.replace(/^\*/, '') }))"
                                      item-text="text"
                                      item-value="value"
                                      label="-กรุณาเลือกแขวง/ตำบล-"
                                      solo
                                      dense
                                      style="
                                        font-family: 'Bai Jamjuree', sans-serif;
                                        width: 320px;
                                        max-width: 100%;
                                        min-width: 180px;
                                      "
                                      v-bind:class="[Error.errorSubDistrict]"
                                    />
                                  </md-field>
                                  <div v-if="Error.errorSubDistrict" class="txt-wrong">{{ Error.errorMsg }}</div>
                                </div>
                              </div>
                            </b-col>
                            <b-col xl style="padding: 0px 1px 0px 10px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 60px; margin-right: 8px;">รหัสไปรษณีย์ <span v-if="!newShipment.acc_zip_code" style="color:red">*</span></div>
                                <div class="detail" style="flex: 1;">
                                  <md-field>
                                    <v-select
                                      v-model="newShipment.acc_zip_code"
                                      :items="zipCodeList.map(z => ({ text: z.ZIPCODE, value: z.ZIPCODE }))"
                                      item-text="text"
                                      item-value="value"
                                      label=""
                                      solo
                                      dense
                                      style="
                                        font-family: 'Bai Jamjuree', sans-serif;
                                        width: 320px;
                                        max-width: 100%;
                                        min-width: 180px;
                                      "
                                      v-bind:class="[Error.errorZipcode]"
                                    />
                                  </md-field>
                                  <div v-if="Error.errorZipcode" class="txt-wrong">{{ Error.errorMsg }}</div>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row style="margin-bottom: 0px;">
                            <b-col xl style="padding: 0px 1px 0px 1px;">
                              <div class="md-layout" style="display: flex; align-items: center;">
                                <div class="head" style="min-width: 60px; margin-right: 8px;">
                                  ค่าเริ่มต้น
                                </div>
                                <div class="detail" style="flex: 1;">
                                  <v-checkbox
                                    v-model="newShipment.is_default"
                                    color="success"
                                    hide-details
                                    style="margin:0;"
                                  />
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                        </b-container>
                      </div>

                      <div class="box-footer">
                        <span
                          @click="
                            dialogAddShipment = false;
                            newShipment = {
                              acc_name: '',
                              acc_phone: '',
                              acc_address: '',
                              acc_province: '',
                              acc_district: '',
                              acc_sub_district: '',
                              acc_zip_code: '',
                              acc_email: '',
                              is_default: false
                            };
                            isEditShipment = false;
                            editShipmentIndex = null;
                          "
                          style="cursor: pointer;"
                        >ยกเลิก</span>
                        <v-btn rounded @click="addShipment" class="ok" :style="{ 'margin-left': '20px' }">
                          {{ isEditShipment ? 'บันทึกการแก้ไข' : 'บันทึก' }}
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
            </div>
            
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfrimEdit" persistent max-width="454px">
      <v-card style="border-radius: 40px;padding: 0;">
        <v-card-text style="border-radius:40px;padding: 0;">
          <v-container
            style="display: flex;
               border-radius: 40px 40px 0 0;
                background-color: rgb(236, 241, 255);
                justify-content: center;
                font-family: 'Bai Jamjuree', sans-serif 
                "
          >
            <div class="my-layout">
              <div><img class="img" src="@/assets/images/lock.png" /></div>
              <div>คุณต้องการ<b>เปลี่ยนรหัสผ่าน</b>ใช่หรือไม่</div>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="font-family: 'Bai Jamjuree', sans-serif ; display: flex;
              justify-content: center;"
        >
          <button
            @click="confrim_dialog('OK')"
            style="width: 84px;
                    height: 35px;
                    background: #000000;
                    border-radius: 8px;
                    color:#fff;
                    "
          >
            ใช่
          </button>
          <button
            @click="confrim_dialog('cancel')"
            style="
                    margin:0 0 0 20px;
                    width: 84px;
                    height: 35px;
                    background: #fff;
                    border-radius: 8px;
                    color:#000;
                    border:2px solid #000;
                    "
          >
            ไม่
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_success"
      persistent
      max-width="350"
      id="dialogCinfrim"
    >
      <v-card style="border-radius:14px">
        <v-card-title style="background-color:#ECF1FF;" class="text-h5 ">
          <div style="width: 100%;">
            <!-- <div style="width: 80%;">บันทึกการเปลี่ยนแปลง</div> -->
            <!-- <div style="justify-content: flex-end;display: flex;width: 20%"><span @click="close_success" style="cursor: pointer;" class="mdi mdi-close mdi-18px"></span></div> -->
            <div style="text-align: center;margin-bottom:20px">
              <img
                class="img"
                src="@/assets/images/success.png"
                style="height:120px"
              />
            </div>
            <div
              style="font-family: 'Bai Jamjuree';text-align: center;font-size:16px"
            >
              บันทึกสำเร็จ
            </div>
          </div>
        </v-card-title>
        <div style="padding:15px 0px;text-align:center">
          <v-btn
            rounded
            @click="close_success"
            class="ok"
            :style="{ 'margin-left': '20px' }"
            >ตกลง</v-btn
          >
          <!-- @click="close_success" -->
        </div>
      </v-card>
    </v-dialog>

    <div class="text-center"></div>
  </div>
</template>

<script>
var CryptoJS = require('crypto-js')
import addressData from '@/components/shippop-address/address.json';
export default {
  name: 'admin-user-manage-detail-dialog',
  props: {
    data: Object,
    temp_data: Object,
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      multiLine: true,
      snackbar: false,
      textSnack: '',
      y: 'top',

      pass: '999999',
      windowSize: 1366,
      dialog_success: false,
      confirmText: '',
      confirmBtn: '',
      confirmDialog: false,
      dialogDetail: true,
      dialogConfrimEdit: false,
      switch1: false,
      editUser: false,
      editPassword: false,
      icon_eye: {
        password: false,
        new_password: false,
        confrim_new_password: false
      },
      edit_val: {
        val_pass: '',
        new_password: '',
        confrim_password: ''
      },
      Error: {
        errorClassNewPwd: '',
        errorClassNewPwd_txt: '',
        errorClassConfNewPwd: '',
        errorClassConfNewPwd_txt: ''
      },
      monthsShort: [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.'
        // 'JAN',
        // 'FEB',
        // 'MAR',
        // 'APR',
        // 'MAY',
        // 'JUN',
        // 'JUL',
        // 'AUG',
        // 'SEP',
        // 'OCT',
        // 'NOV',
        // 'DEC'
      ],
      tempSnackbar: false,
      tempData: JSON.parse(JSON.stringify(this.data)),
      tab: 'userDetail',
      dialogAddShipment: false,
      provinceList: [],
      districtList: [],
      subDistrictList: [],
      zipCodeList: [],
      newShipment: {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: '',
        is_default: true      // ค่าเริ่มต้น
      },
      shipmentList: [],
      isEditShipment: false,
      editShipmentIndex: null,
      userShipmentList: [],
    }
  },
  computed: {
  //   userShipmentList() {
  //   // กรอง shipmentList เฉพาะ user_id ที่กำลังดู
  //   console.log('user_id:', this.data.user_id, 'shipmentList:', this.shipmentList);
  //   return this.shipmentList.filter(
  //     s => String(s.user_id) === String(this.data.user_id)
  //   );
  // },
    dialog: {
      get () {
        return this.show
      },
      set (value) {
        this.close()
      }
    }
  },
  watch: {
    'newShipment.acc_province'(val) {
      // หาอำเภอทั้งหมดในจังหวัดที่เลือก
      const uniqueDistricts = [...new Set(
        this.addressData
          .filter(item => item.province === val)
          .map(item => item.district)
      )];
      
      this.districtList = uniqueDistricts.sort().map(district => ({ 
        DISTRICT_NAME: district, 
        value: district 
      }));
      
      if (!this.isEditShipment) {
        this.newShipment.acc_district = '';
        this.subDistrictList = [];
        this.zipCodeList = [];
        this.newShipment.acc_sub_district = '';
        this.newShipment.acc_zip_code = '';
      }
    },
    'newShipment.acc_district'(val) {
      // หาตำบลทั้งหมดในอำเภอที่เลือก
      const uniqueSubDistricts = [...new Set(
        this.addressData
          .filter(item => item.province === this.newShipment.acc_province && item.district === val)
          .map(item => item.district__1)
      )];
      
      this.subDistrictList = uniqueSubDistricts.sort().map(subDistrict => ({ 
        SUB_DISTRICT_NAME: subDistrict, 
        value: subDistrict 
      }));
      
      // หารหัสไปรษณีย์ทั้งหมดของอำเภอที่เลือก
      this.zipCodeList = this.addressData
        .filter(item => item.province === this.newShipment.acc_province && item.district === val)
        .map(item => ({ ZIPCODE: item.zip_code, value: item.zip_code }))
        .filter((zip, index, self) => index === self.findIndex(z => z.ZIPCODE === zip.ZIPCODE))
        .sort((a, b) => a.ZIPCODE - b.ZIPCODE);
      
      if (!this.isEditShipment) {
        this.newShipment.acc_sub_district = '';
        this.newShipment.acc_zip_code = this.zipCodeList.length > 0 ? this.zipCodeList[0].ZIPCODE : '';
      }
    },
    'newShipment.acc_sub_district'(val) {
      if (val && this.newShipment.acc_province && this.newShipment.acc_district) {
        // หารหัสไปรษณีย์สำหรับตำบลที่เลือก
        const zipCodesForSubDistrict = this.addressData
          .filter(item => 
            item.province === this.newShipment.acc_province && 
            item.district === this.newShipment.acc_district && 
            item.district__1 === val
          )
          .map(item => item.zip_code)
          .filter((zip, index, self) => self.indexOf(zip) === index)
          .sort((a, b) => a - b);
        
        if (zipCodesForSubDistrict.length === 1) {
          // ถ้ามีรหัสไปรษณีย์เพียงอันเดียว ให้เลือกไปเลย
          this.newShipment.acc_zip_code = zipCodesForSubDistrict[0];
          
          // แสดงเฉพาะรหัสไปรษณีย์อันเดียว
          this.zipCodeList = zipCodesForSubDistrict.map(zip => ({ 
            ZIPCODE: zip, 
            value: zip 
          }));
        } else if (zipCodesForSubDistrict.length > 1) {
          // ถ้ามีหลายอัน ให้แสดงให้เลือก
          this.zipCodeList = zipCodesForSubDistrict.map(zip => ({ 
            ZIPCODE: zip, 
            value: zip 
          }));
          
          // ไม่ auto select ให้ผู้ใช้เลือกเอง
          if (!this.isEditShipment) {
            this.newShipment.acc_zip_code = '';
          }
        }
      }
    },
    data: {
      handler() {
        this.fetchShipmentList();
      },
      immediate: true
    }
  },
  mounted() {
    // สร้างรายการจังหวัดที่ไม่ซ้ำกัน
    const uniqueProvinces = [...new Set(addressData.map(item => item.province))];
    this.provinceList = uniqueProvinces.sort().map(province => ({ 
      PROVINCE_NAME: province, 
      value: province 
    }));
    
    // เก็บข้อมูลทั้งหมดไว้ใช้งาน
    this.addressData = addressData;
    this.districtList = [];
    this.subDistrictList = [];
    this.zipCodeList = [];
  },
  methods: {
    setDefaultShipment(shipment, index) {
      if (shipment.is_default === 1) return;
      const data = {
        event: 'set_default',
        id: shipment.id,
        user_id: this.data.user_id
      };
      this.$store.dispatch('fetchShipmentList', data)
        .then(() => {
          this.fetchShipmentList();
        });
    },
    edit (param) {
      if (param == 'edit') {
        this.editUser = true
      } else if (param == 'save') {
        if (this.editPassword) {
          let inp1 = this.checkErrorCase(
            'inp-new-password',
            this.edit_val.new_password
          )
          let inp2 = this.checkErrorCase(
            'inp-conf-new-password',
            this.edit_val.confrim_password
          )
          // console.log('save' , inp1 , inp2)
          let inp3 = false
          if (inp1 && inp2) {
            inp3 = this.checkErrorCase('inp-check-conf-pass', '')
          }

          if (inp1 && inp2 && inp3) {
            this.tempSnackbar =
              this.data.user_status == this.tempData.user_status ? false : true

            var pwd = this.edit_val.new_password
            let keyapp = 'DropShipSecretKey'
            var encrypted = CryptoJS.AES.encrypt(pwd, keyapp)

            let res = {
              user_id: this.data.user_id,
              new_password: encodeURI(encrypted),
              user_status: this.data.user_status
            }
            this.$store
              .dispatch('changePwdStatus', res)
              .then(res => {
                // console.log(res)
              })
              .catch(error => {
         
                if (error.response.status == 400) {
                }
              })
            this.dialogDetail = false
            this.dialog_success = true
          } else {
            // console.log('Not Save')
          }
        } else {
          this.tempSnackbar = true
          let res = {
            user_id: this.data.user_id,
            new_password: '',
            user_status: this.data.user_status
          }

          this.$store
            .dispatch('changePwdStatus', res)
            .then(res => {
              this.dialogDetail = false
              this.dialog_success = true
            })
            .catch(error => {
         
              if (error.response.status == 400) {
              }
            })
        }
      } else {
        this.Error.errorClassNewPwd = ''
        this.Error.errorClassNewPwd_txt = ''
        this.Error.errorClassConfNewPwd = ''
        this.Error.errorClassConfNewPwd_txt = ''
        ;(this.icon_eye.password = false),
          (this.icon_eye.new_password = false),
          (this.icon_eye.confrim_new_password = false)
        ;(this.edit_val.val_pass = ''), (this.edit_val.new_password = '')
        this.edit_val.confrim_password = ''

        this.editPassword = false
        this.editUser = false
      }
    },
    checkErrorCase (type, value) {
      if (type == 'inp-new-password') {
        if (value == null || value == '') {
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong10')
          return false
        } else {
          this.Error.errorClassNewPwd = ''
          this.Error.errorClassNewPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-conf-new-password') {
        if (value == null || value == '') {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong10')
          return false
        } else {
          this.Error.errorClassConfNewPwd = ''
          this.Error.errorClassConfNewPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-check-conf-pass') {
        if (this.edit_val.new_password != this.edit_val.confrim_password) {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong8')
          return false
        } else {
          this.Error.errorClassNewPwd = ''
          this.Error.errorClassConfNewPwd = ''
          this.Error.errorClassConfNewPwd_txt = ''
          return true
        }
      }
    },
    HideShow (param) {
      if (param == 'password') {
        if (this.icon_eye.password) {
          this.icon_eye.password = false
        } else {
          this.icon_eye.password = true
        }
      }

      if (param === 'new_password') {
        if (this.icon_eye.new_password) {
          this.icon_eye.new_password = false
        } else {
          this.icon_eye.new_password = true
        }
      }
      if (param == 'confrim_new_password') {
        if (this.icon_eye.confrim_new_password) {
          this.icon_eye.confrim_new_password = false
        } else {
          this.icon_eye.confrim_new_password = true
        }
      }
    },
    formatDate (val) {
      if (val !== null) {
        let hours = ''
        let min = ''
        let today = new Date(val)
        const year = today.getFullYear()
        const fullYear = year
        // const fullYear = year + 543
        const days = today.getDate()
        const h = today.getHours()
        const m = today.getMinutes()
        const monthName = this.monthsShort[today.getMonth()]

        if (h < 10) {
          hours = '0' + h
        } else {
          hours = h
        }

        if (m < 10) {
          min = '0' + m
        } else {
          min = m
        }

        return (
          days +
          ' ' +
          monthName +
          ' ' +
          fullYear +
          '  ' +
          hours +
          ':' +
          min +
          ' น.'
        )
      } else {
        return val
      }
    },
    cheang_password () {
      this.dialogConfrimEdit = true
    },
    confrim_dialog (param) {
      this.dialogConfrimEdit = false
      if (param == 'OK') {
        this.editPassword = true
      } else {
        // console.log('cancel')
      }
    },
    renderStatus (row, mode) {
      if (mode == 'class') {
        return row.user_status == 1 ? 'active' : 'inactive'
      } else {
        return row.user_status == 1 ? 'Active' : 'Inactive'
      }
    },
    switch_user (param) {
      if (param.user_status == 0) {
        this.data.user_status = 1
      } else {
        this.data.user_status = 0
      }
    },
    close () {
      this.$emit('close', {})
      this.$emit('fetch', {})
    },
    close_success () {
      let status = ''
      if (this.data.user_status == 1) {
        status = 'Active บัญชีผู้ใช้งาน'
      } else {
        status = 'Inactive บัญชีผู้ใช้งาน'
      }
      let detail_snack = {
        status_code: this.data.user_status,
        status: status,
        user_name: this.data.user_name, //+ ' ' + this.data.user_surname,
        show: this.tempSnackbar
      }
      this.$emit('snack', detail_snack)
      this.$emit('close', {})
    },
    syntaxPassword (password) {
      var regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/
      if (regex.test(password)) {
        return true
      } else {
        return false
      }
    },
    onResize () {
      if (this.data.user_status == 1) {
        this.switch1 = true
      } else {
        this.switch1 = false
      }
      let x = window.innerWidth
      let y = window.innerHeight
      this.windowSize = x
      this.deviceType = window.deviceType()
    },
    openAddShipmentDialog() {
      this.dialogAddShipment = true;
      this.isEditShipment = false;
      this.editShipmentIndex = null;
      this.newShipment = {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: ''
      };
    },
    view(row) {
    this.$emit('viewEdit', row)
    },
    remove(row) {
      this.$emit('remove', row)
    },
    view_add() {
      this.$emit('viewAdd')
    },
    editShipment(shipment, index) {
      this.dialogAddShipment = true;
      this.isEditShipment = true;
      this.editShipmentIndex = index;
      
      // Map field จาก backend ให้ตรงกับฟอร์ม
      this.newShipment = {
        acc_name: shipment.from_name || '',
        acc_phone: shipment.from_tel || '',
        acc_address: shipment.from_address || '',
        acc_province: shipment.from_province || '',
        acc_district: shipment.from_state || '',
        acc_sub_district: shipment.from_district || '',
        acc_zip_code: shipment.from_postcode || '',
        acc_email: shipment.from_email || '',
        is_default: shipment.is_default === 1
      };

      // 1. อัปเดต districtList
      const selectedProvince = this.provinceList.find(p => p.PROVINCE_NAME === this.newShipment.acc_province);
      if (selectedProvince) {
        this.districtList = districts.filter(d => d.PROVINCE_ID === selectedProvince.PROVINCE_ID);
      }

      // 2. อัปเดต subDistrictList
      const selectedDistrict = this.districtList.find(d => d.DISTRICT_NAME.replace(/^\*/, '') === this.newShipment.acc_district);
      if (selectedDistrict) {
        this.subDistrictList = subDistricts.filter(s => s.DISTRICT_ID === selectedDistrict.DISTRICT_ID);
      }

      // 3. อัปเดต zipCodeList
      const selectedSubDistrict = this.subDistrictList.find(s => s.SUB_DISTRICT_NAME.replace(/^\*/, '') === this.newShipment.acc_sub_district);
      if (selectedSubDistrict) {
        this.zipCodeList = zipcodes.filter(z => z.SUB_DISTRICT_ID === selectedSubDistrict.SUB_DISTRICT_ID);
      }
      this.$nextTick(() => {
        if (this.newShipment.acc_zip_code && this.zipCodeList.length > 0) {
          const existingZip = this.zipCodeList.find(z => z.ZIPCODE === this.newShipment.acc_zip_code);
          if (!existingZip) {
            this.newShipment.acc_zip_code = this.zipCodeList[0].ZIPCODE;
          }
        }
      });
    },
    
    deleteShipment(shipment, index) {
      this.$store.dispatch('fetchShipmentList', {
        event: 'delete',
        id: shipment.id,
        user_id: this.data.user_id
      })
        .then(() => {
          this.fetchShipmentList();
        });
      // ล้างค่า newShipment และสถานะแก้ไข
      this.newShipment = {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: ''
      };
      this.isEditShipment = false;
      this.editShipmentIndex = null;
    },
    addShipment() {
      // Reset error class
      this.Error = {
        errorName: '',
        errorPhone: '',
        errorAddress: '',
        errorProvince: '',
        errorDistrict: '',
        errorSubDistrict: '',
        errorZipcode: '',
        errorMsg: ''
      };

      // ตรวจสอบแต่ละช่อง
      if (!this.newShipment.acc_name) this.Error.errorName = 'error-case';
      if (!this.newShipment.acc_phone) this.Error.errorPhone = 'error-case';
      if (!this.newShipment.acc_address) this.Error.errorAddress = 'error-case';
      if (!this.newShipment.acc_province) this.Error.errorProvince = 'error-case';
      if (!this.newShipment.acc_district) this.Error.errorDistrict = 'error-case';
      if (!this.newShipment.acc_sub_district) this.Error.errorSubDistrict = 'error-case';
      if (!this.newShipment.acc_zip_code) this.Error.errorZipcode = 'error-case';

      // ถ้ามีช่องไหนไม่ได้กรอก
      if (
        this.Error.errorName ||
        this.Error.errorPhone ||
        this.Error.errorAddress ||
        this.Error.errorProvince ||
        this.Error.errorDistrict ||
        this.Error.errorSubDistrict ||
        this.Error.errorZipcode
      ) {
        this.Error.errorMsg = 'กรุณากรอกข้อมูลให้ครบ';
        return;
      }

      // Mapping ข้อมูลให้ตรงกับ table shipment_from
      const shipmentData = {
        event: this.isEditShipment ? 'update' : 'insert',
        id: this.isEditShipment && this.userShipmentList[this.editShipmentIndex] ? this.userShipmentList[this.editShipmentIndex].id : null,
        user_id: this.data.user_id,
        from_name: this.newShipment.acc_name,
        from_address: this.newShipment.acc_address,
        from_district: this.newShipment.acc_sub_district,
        from_state: this.newShipment.acc_district,
        from_province: this.newShipment.acc_province,
        from_postcode: this.newShipment.acc_zip_code,
        from_country: 'Thailand',
        from_email: this.newShipment.acc_email || '',
        from_tel: this.newShipment.acc_phone,
        is_default: this.newShipment.is_default ? 1 : 0
      };

      this.$store
        .dispatch('fetchShipmentList', shipmentData)
        .then(res => {
          this.dialogAddShipment = false;
          this.dialog_success = true;
          // โหลด shipmentList ใหม่จาก backend
          this.fetchShipmentList();
          this.isEditShipment = false;
          this.editShipmentIndex = null;
          // Reset newShipment
          this.newShipment = {
            acc_name: '',
            acc_phone: '',
            acc_address: '',
            acc_province: '',
            acc_district: '',
            acc_sub_district: '',
            acc_zip_code: '',
            acc_email: '',
            is_default: false
          };
        })
        .catch(error => {
        });
    },
    //ดึงแบบนี้
    fetchShipmentList() {
      const data = {
        event: 'get_all',
        user_id: this.data.user_id
      };
      this.$store
        .dispatch('fetchShipmentList', data)
        .then(res => {
          // กรองเฉพาะ shipment ที่ user_id ตรงกับที่กำลังดู
          const filtered = Array.isArray(res)
            ? res.filter(s => String(s.user_id) === String(this.data.user_id))
            : [];
          console.log('fetchShipmentList response:', filtered);
          this.userShipmentList = filtered;
        });
    }
  }
}
</script>
<style>
.error-case {
  border-color: red !important;
  font-size: 12px;
  font-family: 'Bai Jamjuree', sans-serif;
}

</style>
